import { AxiosRequestConfig } from 'axios'

import { UpdateLegalTextsPayload } from './types'

const getLegalTexts = (): AxiosRequestConfig => ({
  url: '/legal',
  method: 'GET',
})

const updateLegalTexts = (payload: UpdateLegalTextsPayload): AxiosRequestConfig => ({
  url: '/legal',
  method: 'PUT',
  data: payload,
})

export { getLegalTexts, updateLegalTexts }
